import React from "react";
import { Button } from "@shared/components/Common";
import { Icon } from "@shared/components/Icon";

import "./index.scss";

interface SidebarBackButtonProps {
  onClick?: () => void;
}

const SidebarBackButton = (props: SidebarBackButtonProps) => {
  const { onClick } = props;

  return (
    <div className="sidebar-back-btn-container">
      <Button className="sidebar-back-btn" onClick={onClick}>
        <Icon type="arrow-left" />
      </Button>
      Back
    </div>
  );
};

export default SidebarBackButton;
